export function addMessage(elem, text) {
  removeMessage();
  let messageElem = `<p class="control__message">${text}</p>`;
  elem.classList.add('control__input--error');
  insertMessage(elem, messageElem);
  addHandler(elem);
}

function insertMessage(elem, messageElem) {
  if (elem.classList.contains('suggestions-input')) {
    let suggest = elem.nextElementSibling;
    suggest.insertAdjacentHTML('afterend', messageElem);
  } else {
    elem.insertAdjacentHTML('afterend', messageElem);
  }
}

function removeMessage() {
  let messageElem = document.querySelector('.control__message');
  if (messageElem) {
    messageElem.remove();
  }
}

function addHandler(elem) {
  elem.addEventListener('focus', inputFocusHandler);
  elem.addEventListener('input', inputInputHandler);
}

function inputFocusHandler(evt) {
  let elem = evt.target;
  elem.classList.remove('control__input--error');
  elem.removeEventListener('focus', inputFocusHandler);
}

function inputInputHandler(evt) {
  let elem = evt.target;
  elem.classList.remove('control__input--error');
  removeMessage();
  elem.removeEventListener('input', inputInputHandler);
}
